import React from 'react'

export const ChapterContext = React.createContext()
